
import {WaitListCoverImage as _WaitListCoverImage} from './_WaitListCoverImage';

export const WaitListCoverImage = _WaitListCoverImage;

export default WaitListCoverImage;
